import React from 'react';
import styled from 'styled-components';
import { HealthToolCard, HealthToolCardData } from './HealthToolCard';

interface HealthToolsCardsProps {
  toolsData: Array<HealthToolCardData>;
}

interface HealthToolsRowProps {
  items: number;
}

const HealthToolsRow = styled.div<HealthToolsRowProps>`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(${props => props.items}, 30%);
  justify-content: center;
  gap: 2.2rem;

  margin-bottom: 2.2rem;

  & div {
    cursor: pointer;
    width: 100%;
  }
`;

const TOOLS_PER_ROW = 3;

const getRowTools = (
  currentRowIndex: number,
  toolsData: HealthToolCardData[]
): HealthToolCardData[] => {
  const currentToolIndex = TOOLS_PER_ROW * currentRowIndex;
  const lastToolIndex = TOOLS_PER_ROW * (currentRowIndex + 1);
  const currentRow = [];

  for (
    let toolIndex = currentToolIndex;
    toolIndex < lastToolIndex && toolIndex < toolsData.length;
    toolIndex += 1
  ) {
    currentRow.push(toolsData[toolIndex]);
  }

  return currentRow;
};

const getToolsPerRow = (toolsData: HealthToolCardData[]): HealthToolCardData[][] => {
  const totalRows = Math.ceil(toolsData.length / TOOLS_PER_ROW);
  const toolsPerRow = [];

  for (let currentRowIndex = 0; currentRowIndex < totalRows; currentRowIndex += 1) {
    const currentRow = getRowTools(currentRowIndex, toolsData);
    toolsPerRow.push(currentRow);
  }

  return toolsPerRow;
};

export default function HealthToolsCards(props: HealthToolsCardsProps) {
  const toolsPerRow = getToolsPerRow(props.toolsData);

  return (
    <>
      {toolsPerRow.map(currentRow => (
        <HealthToolsRow items={currentRow.length}>
          {currentRow.map(toolData => (
            <HealthToolCard toolData={toolData} />
          ))}
        </HealthToolsRow>
      ))}
    </>
  );
}
